




















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

@Component({})
export default class GtDialog extends Vue {
  @Prop({ default: "Title", type: String }) dialogTitle;
  @Prop({ type: Object, default: () => ({}) })
  dialogRowInfo;

  private dialogFormVisible: Boolean = false;
  formLabelWidth: "120px";

  handleCancel() {
    this.dialogFormVisible = false;
    this.$emit("dialogHandleCancel", this.dialogRowInfo);
  }
  handleOK() {
    // this.dialogFormVisible = false;
    this.$emit("dialogHandleOK", this.dialogRowInfo);
  }
}
